<template>
  <div class="tab-page">
    <div class="type-wrapper">
      <span
        :class="{ active: type === 'export_csv' }"
        @click="selectType('export_csv')"
      >
        {{ $t('text.export_csv') }}
      </span>
    </div>
    <ExportCSV v-if="type === 'export_csv'" />
  </div>
</template>

<script>
import ExportCSV from '@/components/reports/ExportCSV'
export default {
  data() {
    return {
      type: 'export_csv'
    }
  },
  components: {
    ExportCSV
  },
  methods: {
    selectType(type) {
      this.type = type
    }
  }
}
</script>
